import ReactApexChart from "react-apexcharts";
import { Col, Row } from "react-bootstrap";

const StackBarChart = ({ graph }) => {
  const chartData = {
    series: graph?.totalData?.map((item) => ({
      name: item.name,
      data: item.data,
    })),
    options: {
      chart: {
        type: "bar",
        height: 350,
        stacked: true,
      },
      plotOptions: {
        bar: { horizontal: true, dataLabels: { position: "top" } },
      },
      dataLabels: {
        enabled: false,
      },
      xaxis: {
        categories: graph?.totalCategory || [],
      },
      fill: {
        opacity: 1,
      },
      colors: graph?.categoryColor?.map(item => item?.color) ?? [],
      tooltip: { shared: true, intersect: false },
      legend: {
        position: "top",
      },
    },
  };

  return (
    <>
      <div
        className="d-flex align-items-center justify-content-between graph__title__border bg-body-secondary"
        style={{ borderBottom: "1px solid rgb(229, 229, 229)" }}
      >
        <h6 className="m-0 fontSize12 fw-bold">
          {graph?.graphName || "Stack Bar Chart"}
        </h6>
      </div>

      <Row>
        <Col md={1} className="chart_yaxis_legend">
          <p className="fw-bold">{graph?.yAxisName}</p>
        </Col>
        <Col md={11}>
          <div id="chart" className="p-0">
            <ReactApexChart
              options={chartData.options}
              series={chartData.series}
              type="bar"
              height={350}
            />
          </div>
          <div className="chart_xaxis_legend">
            <p className="fw-bold">{graph?.xAxisName}</p>
          </div>
        </Col>
      </Row>
    </>
  );
};

export default StackBarChart;
